"use client";
import * as React from "react";
const SvgTaskRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.02 4.33 9.1.46A1.6 1.6 0 0 0 7.95 0H2.13A1.6 1.6 0 0 0 .5 1.6v12.8c0 .88.72 1.6 1.62 1.6h9.75c.9 0 1.63-.72 1.63-1.6V5.46c0-.42-.17-.83-.48-1.13m-7.46 7.9-1.72-1.7a.8.8 0 0 1 0-1.12.8.8 0 0 1 1.14 0l1.15 1.13L9.01 7.7a.8.8 0 0 1 1.14 0 .8.8 0 0 1 0 1.13l-3.44 3.4a.8.8 0 0 1-1.15 0M8.63 5.6a.8.8 0 0 1-.82-.8V1.2l4.47 4.4z" }));
export {
  SvgTaskRound as default
};
